module.exports = __webpack_public_path__ + "img/1.dc38ef82.jpg";